export default __webpack_public_path__ + "static/media/cal-male-condom.b35e38df.jpg";